import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { chartImageScaleFactor, defaultAreaId } from "../../../constants";
import exportCharts from "../../multipleChartExporting";
import AreaChooser from "../../choosers/AreaChooser";
import ChangeByMethodChart from "./ChangeByMethodChart";
import DataViewerFrame from "../../widgets/DataViewerFrame";

const ChangeByMethodChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const chartRefs = {};

  return (
    <DataViewerFrame
      dataViewerId="change_by_method_chart"
      reference={props.reference}
      title={props.title}
      subtitle={props.subtitle}
      filters={[
        <AreaChooser
          id={props.chooserId}
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: `theme5.${props.id}`,
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          area: props.database.areas[areaId].area
        });
      }}
      onDownloadPng={() => {
        exportCharts(chartRefs, {
          filename: "change_by_method_chart",
          scale: chartImageScaleFactor
        });
      }}
    >
      <ChangeByMethodChart
        database={props.database}
        data={props.data}
        yAxisTitle={props.yAxisTitle}
        areaId={areaId}
        tooltipFormatter={props.tooltipFormatter}
        onRegisterChartRef={(key, ref) => {
          if (ref) {
            chartRefs[key] = ref;
          } else {
            delete chartRefs[key];
          }
        }}
      />
    </DataViewerFrame>
  );
};

ChangeByMethodChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  reference: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  chooserId: PropTypes.string.isRequired,
  tooltipFormatter: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ChangeByMethodChartWidget;
